import { createContext, useContext, useState, type ReactNode } from 'react';

export const AUTH_ERROR = 'SESSION_EXPIRED' as const;

export class SessionExpiredError extends Error {
  constructor() {
    super('Session expired');
    this.name = 'SessionExpiredError';
  }
}

interface AuthSessionContextValue {
  sessionExpired: boolean;
  setSessionExpired: (v: boolean) => void;
}

const AuthSessionContext = createContext<AuthSessionContextValue>({
  sessionExpired: false,
  setSessionExpired: () => {},
});

export function AuthSessionProvider({ children }: { children: ReactNode }) {
  const [sessionExpired, setSessionExpired] = useState(false);
  return (
    <AuthSessionContext.Provider value={{ sessionExpired, setSessionExpired }}>
      {children}
    </AuthSessionContext.Provider>
  );
}

export function useSessionStatus() {
  return useContext(AuthSessionContext);
}
